import {
  CATEGORY_LABELS,
  CLIENT_TYPE_LABELS,
  EXTERNAL_CLIENT_OPTIONS,
  INTERNAL_CLIENT_OPTIONS,
  MARKET_LABELS,
  PROFILE_LABELS
} from '../data/knowledgeBase';
import type { ClientType, CustomerBehaviorProfile, FoodCategory, Market } from '../types';

interface InputPanelProps {
  customerProfile: CustomerBehaviorProfile;
  onCustomerProfileChange: (value: CustomerBehaviorProfile) => void;
  category: FoodCategory;
  onCategoryChange: (value: FoodCategory) => void;
  market: Market;
  onMarketChange: (value: Market) => void;
  clientType: ClientType;
  onClientTypeChange: (value: ClientType) => void;
  value: string;
  onChange: (value: string) => void;
}

const profileOptions = Object.entries(PROFILE_LABELS) as Array<[CustomerBehaviorProfile, string]>;
const categoryOptions = Object.entries(CATEGORY_LABELS) as Array<[FoodCategory, string]>;
const marketOptions = Object.entries(MARKET_LABELS) as Array<[Market, string]>;

export const InputPanel = ({
  customerProfile,
  onCustomerProfileChange,
  category,
  onCategoryChange,
  market,
  onMarketChange,
  clientType,
  onClientTypeChange,
  value,
  onChange
}: InputPanelProps) => {
  const charCount = value.trim().length;
  const clientOptions = market === 'interno' ? INTERNAL_CLIENT_OPTIONS : EXTERNAL_CLIENT_OPTIONS;

  return (
    <section className="panel panel--input">
      <div className="panel__filters panel__filters--wide">
        <label className="panel__field">
          <span className="panel__field-label">Perfil comportamental do cliente</span>
          <select className="panel__select" value={customerProfile} onChange={(event) => onCustomerProfileChange(event.target.value as CustomerBehaviorProfile)}>
            {profileOptions.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>

        <label className="panel__field">
          <span className="panel__field-label">Categoria principal</span>
          <select className="panel__select" value={category} onChange={(event) => onCategoryChange(event.target.value as FoodCategory)}>
            {categoryOptions.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>

        <label className="panel__field">
          <span className="panel__field-label">Mercado</span>
          <select className="panel__select" value={market} onChange={(event) => onMarketChange(event.target.value as Market)}>
            {marketOptions.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>

        <label className="panel__field">
          <span className="panel__field-label">Tipo de cliente</span>
          <select className="panel__select" value={clientType} onChange={(event) => onClientTypeChange(event.target.value as ClientType)}>
            {clientOptions.map((option) => (
              <option key={option} value={option}>
                {CLIENT_TYPE_LABELS[option]}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="panel__heading-row">
        <label htmlFor="scenario-input" className="panel__label">
          Descreva o cenário da reunião
        </label>
        <span className="panel__counter">{charCount} caracteres úteis</span>
      </div>

      <textarea
        id="scenario-input"
        className="panel__textarea"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={`Exemplo: Reunião com rede regional para revisar a categoria de embutidos.
O comprador está pressionando por preço, mas a loja sofre com ruptura e mix pouco rentável.
Queremos defender margem, abrir espaço para novos SKUs e construir um plano com contrapartida comercial.`}
      />

      <p className="panel__helper">
        Traga o máximo de contexto real da conta: objetivo da reunião, estágio da negociação, pressão por preço, indicadores, gargalos de mix, exposição, ruptura, abastecimento e o que o cliente quer destravar agora.
      </p>
    </section>
  );
};
